import { realpath } from 'fs';
// import { el } from '@angular/platform-browser/testing/browser_util';
import { Jsonp } from '@angular/http';
import { Component, ViewEncapsulation, Input } from '@angular/core';
import { JsonComponentService } from '../json-component.service';

const _ = require('lodash');
const generateSchema = require("generate-schema");

@Component({
    selector: "json-form",
    styles: [require('./json-form.css')],
    providers:[],
    template: `
<nav *ngIf="nav.length > 0" class="breadcrumb">
  <a (click)="onNav(-1)">Root</a><span *ngFor="let e of nav;let index = index;">&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i> <a (click)="onNav(index)">{{e.path.join(".")}}</a> </span> 
</nav>

<json-form-internal [context]="getCurrentContext()" [editMode]="editMode">
</json-form-internal>
    `
})
export class JsonFormComponent {
  @Input('schema')
  public inputSchema: any;
  @Input('json')
  public json: any;
  @Input('editMode')
  public editMode = false;

  schema: any;
  nav=[];

  static ID = 0;
  id = JsonFormComponent.ID++;

  constructor(private jsonService: JsonComponentService){

  }

  ngOnChanges(changes) {
    if (changes.json || changes.schema) {
      this.schema = this.inputSchema ? this.inputSchema: this.jsonService.generateSchema(this.json);
      this.nav = [];
    }
  }

  getKeys(props){
    return Object.keys(props);
  }

  getCurrentContext(){
    let nav = this.nav.length? this.nav[this.nav.length - 1] : null;
    return nav? {schema: nav.schema, json: nav.json, path: nav.path, top: this} : 
      {schema: this.schema, json: this.json, path:[],top:this};
  }

  navigate(opt){
    this.nav.push(opt);
  }

  onNav(idx){
    if (idx==-1){
      this.nav=[];
      return;
    } else {
      this.nav.length = idx+1;
    }
  }

}

@Component({
    selector: "json-form-internal",
    styles: [require('./json-form.css')],
    template: ` 
<ng-container [ngSwitch]="context.schema.type">
  <ng-container *ngSwitchCase="'object'">
      <ng-container *ngFor="let key of getKeys(context.schema.properties);" class="">
        <ng-container [ngSwitch]="context.schema.properties[key].type">
          <ng-container *ngSwitchCase="'string'">
            <div class="form-group">
              <label style="word-break: break-all;line-height: 15px;top: 9px;">{{context.path.concat(key).join(".")}}</label>
              <span *ngIf="!editMode">{{context.json[key] || '&nbsp;'}}</span>
              <input *ngIf="editMode" type="text" [(ngModel)]="context.json[key]" [name]="id +':' + context.path.concat(key).join('.')" placeholder="" style="width:100%"> 
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'number'">
            <div class="form-group">
              <label style="word-break: break-all;line-height: 15px;top: 9px;">{{context.path.concat(key).join(".")}}</label>
              <span *ngIf="!editMode">{{context.json[key]}}&nbsp;</span>
              <input *ngIf="editMode" type="number" [(ngModel)]="context.json[key]" [name]="id +':' + context.path.concat(key).join('.')" placeholder="" style="width:100%"> 
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'array'">
            <div class="form-group">
              <label style="word-break: break-all;line-height: 15px;top: 9px;">{{context.path.concat(key).join(".")}}</label>
              <span><a (click)="onArrayClick(key)">(...)</a></span>
            </div>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <json-form-internal [context]="{schema:context.schema.properties[key], json:context.json[key], path:context.path.concat(key), top: context.top}" [editMode]="editMode">
            </json-form-internal>
          </ng-container>
        </ng-container>
      </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'array'">
      <ng-container *ngFor="let e of context.json;let index = index;trackBy: trackBy" class="">
        <div style="border-top: 1px solid #ccc;">
          <div *ngIf="editMode" style="float:right"> 
            <a class="cursor-pointer" (click)="onDeleteArrayItem(index)"><i class="fa fa-close"></i></a>
          </div>
          <json-form-internal *ngIf="context.schema.items.type != 'string'" [context]="{schema:context.schema.items, json:e, path:['['+index+']'], top: context.top}" [editMode]="editMode">
          </json-form-internal>
          <div *ngIf="context.schema.items.type == 'string'">
            <span *ngIf="!editMode">{{context.json[index] || '&nbsp;'}}</span>
            <input *ngIf="editMode" type="text" [(ngModel)]="context.json[index]" [name]="id +':' + context.path.concat(index).join('.')" placeholder="" style="width:calc(100% - 11px)"> 
          </div>
        </div>
      </ng-container>
      <div *ngIf="editMode">              
        <span *ngIf="!context.schema.items.type">
            <i class="fa fa-plus"></i> <a class="cursor-pointer" (click)="onAddArrayUnknown('string')">String</a> <!-- or
            <a class="cursor-pointer" (click)="onAddArrayUnknown('object')"> Object</a> -->
        </span>
        <span *ngIf="context.schema.items.type">
          <a class="cursor-pointer" (click)="onAddArrayItem()"><i class="fa fa-plus"></i></a>
        </span>
      </div>
  </ng-container>
</ng-container>
    `
})
export class JsonFormInternalComponent {

  @Input('context')
  public context={json:null, schema:null, path:[],top:null};
  @Input('editMode')
  public editMode = false;

  static ID = 0;
  id = JsonFormComponent.ID++;

  constructor(private jsonService: JsonComponentService){

  }

  ngOnChanges(changes) {

  }

  getKeys(props){
    return Object.keys(props);
  }

  onArrayClick(key){
    if (!this.context.json[key]) {
      this.context.json[key] = [];
    }
    this.context.top.navigate({json:this.context.json[key],schema:this.context.schema.properties[key],path:this.context.path.concat(key)});
  }

  onAddArrayItem(){
    let type = (this.context.schema.items.type);
    // TODO: current 3rd party inference code doesn't work well if object are incomplete for nested arrays, might have to do own inference and get rid of this code
    this.context.json.push(type == 'string' ? "" : {});
  }

  onAddArrayUnknown(type) {
    this.context.schema.items.type = type;
    if (type="object") {
      //TODO: if we support adding object then we need to let user creat any field they want
      this.context.schema.items.properties={};
    }
    this.onAddArrayItem();
  }

  onDeleteArrayItem(idx){
    this.context.json.splice(idx,1);
  }

  trackBy(index, entry){
    return index;
  }

}


// WEBPACK FOOTER //
// ./src/common/json/json-form/json-form.component.ts